import React, { useState } from 'react';
import { Cascader, message } from 'antd';
import styles from './customCascader.module.scss';
import setRequiredFields from './GaokaoxkStore';
import optional2 from './optional2.module.scss';
import { SVGPureIcon } from '@/ui';
import { observer } from 'mobx-react-lite';

// 报考类别
const options = [
  {
    value: '历史',
    label: '历史',
    children: [
      { value: '化学', label: '化学' },
      { value: '生物', label: '生物' },
      { value: '地理', label: '地理' },
      { value: '政治', label: '政治' },
    ],
  },
  {
    value: '物理',
    label: '物理',
    children: [
      { value: '化学', label: '化学' },
      { value: '生物', label: '生物' },
      { value: '地理', label: '地理' },
      { value: '政治', label: '政治' },
    ],
  },
];

const Classification = props => {
  const { setAreaName } = props;
  const [selectedValues, setSelectedValues] = useState([]);
  const [maxCount, setMaxCount] = useState(2);
  const [dropdownVisible, setDropdownVisible] = useState(false);
 // 新增状态，用于控制文字颜色
  const warningActive=setRequiredFields.warningActive

  const onChange = (value, selectedOptions) => {
    // 检查是否是一级菜单的选择
    const isFirstLevel = selectedOptions.some(option => option.children);
    if (isFirstLevel) {
      // 如果是一级菜单，确保只能选择一个
      if (value.length > 1) {
        message.warning('一级菜单只能选择一个');
        return;
      }

      // 强制触发重新渲染
      setTimeout(() => setSelectedValues([]), 0);
      return; // 直接返回，避免后续逻辑执行
    }

    // 检查二级菜单的选择数量
    const secondLevelValues = selectedOptions.filter(
      option => !option.children
    );
    if (secondLevelValues.length > 2) {
      message.warning('最多只能选择两个');
      return;
    }
    let flattenedAndUniqueValues = [];
    if (Array.isArray(value)) {
      // 如果 value 是嵌套数组，使用 flat；否则直接使用 value
      flattenedAndUniqueValues = [
        ...new Set(value.flat ? value.flat() : value),
      ];
    }

    setSelectedValues(value); // 更新选中值
    setRequiredFields.setWarningActive(false); // 重置警告状态
    setRequiredFields.setRequiredFields({
      optional: flattenedAndUniqueValues,
    });
    setRequiredFields.setOptionalFields({
      optional: value,
    });
    setRequiredFields.setOptionalFields({
      province: flattenedAndUniqueValues[0],
    });
  };

  const onLoadData = selectedOptions => {
    setRequiredFields.clearDackfillData()
    // 清空之前的选中状态
    setSelectedValues([]); // 清空选择框中的数据
    setAreaName(selectedOptions[0]); // 更新一级菜单的值
    // 在这里处理一级菜单点击的逻辑
  };

  // const uniqueSubjects = [...new Set(setRequiredFields.optionalFields.optional.flat())];
  // const tagRender = (props) => {
  //   const { label, value, disabled, closable, onClose, option } = props;
  //   console.log(label, value, disabled, closable, onClose, option,'value, label, closable, onClose');

  //   let firstPart
  //   if(value){
  //       firstPart = value.split('__')[0];

  //   }
  //   return (
  //     <span className="custom-tag" style={{ color: '#006AFF' }}>
  //       {uniqueSubjects.join('、')}
  //     </span>
  //   );
  // };
  const dropdownRender = menus => (
    <div className="custom-dropdown-container">
      <div
        className={`selection-hint ${selectedValues.length === maxCount ? 'completed' : ''}`}
        style={{
          padding: '10px 0 0 10px',
          fontSize: '12px',
          color: '#00000080',
        }}
      >
        {`必选${maxCount}个（ ${selectedValues.length}/${maxCount}）`}
      </div>
      {menus}
    </div>
  );

  const tagRender = props => {
    const { value, label, closable, onClose } = props;
    // const flattenAndDeduplicate=flattenAndDeduplicate(selectedValues)

    let firstPart;
    if (value) {
      firstPart = value.split('__')[0];
    }
    const handleClose = e => {
      e.preventDefault();
      e.stopPropagation();
    };

    return (
      <span
        className="custom-tag"
        style={{color: warningActive ? '#FF2828' : '#006AFF', fontWeight: 700 }}
      >
        {firstPart !== undefined && <span>{`${firstPart}、`}</span>}
        {label}
        {closable && (
          <span className="tag-close-icon" onClick={handleClose}>
            、
          </span>
        )}
      </span>
    );
  };
  const handleDropdownVisibleChange = visible => {
    if (visible) {
      setDropdownVisible(true);
    } else {
      setDropdownVisible(false);

      // 检查选择数量是否达到要求
      if (selectedValues.length < maxCount) {
        if(setRequiredFields.optionalFields.optional?.length!==maxCount){
          setRequiredFields.setWarningActive(true); // 激活警告状态

        }
        message.warning(`请选择${maxCount}个科目`);
      }
    }
    setDropdownVisible(visible);
  };

  return (
    <Cascader
      className={styles['custom-cascader']}
      popupClassName={optional2['custom-cascader-dropdown']} // 应用自定义下拉样式
      style={{
        width: 'auto', // 关键：设置为 auto
        minWidth: 78, // 保留最小宽度
        display: 'inline-block', // 确保宽度自适应
      }}
      allowClear={false}
      multiple
      placeholder="选科"
      options={options}
      value={setRequiredFields.optionalFields.optional} // 绑定选中值
      onDropdownVisibleChange={handleDropdownVisibleChange}
      onChange={onChange}
      loadData={onLoadData}
      tagRender={tagRender}
      dropdownRender={dropdownRender}
      maxTagPlaceholder={omittedValues => (
        <span style={{ color: '#006AFF' }}>...</span>
      )}
      maxTagCount={1}
      // 自定义选择器右侧的下拉箭头
      suffixIcon={
        <SVGPureIcon
          name={dropdownVisible ? 'shangjant' : 'ArrowDown'}
          className=""
          style={{ width: 16, height: 16 }}
        />
      }
      // 自定义下拉菜单中的展开箭头
      expandIcon={
        <SVGPureIcon
          name="ArrowRight"
          className="text-black text-opacity-50"
          style={{
            width: 16,
            height: 16,
          }}
        />
      }
      optionRender={(option, state = {}) => {
        const huoquxuanz=setRequiredFields?.optionalFields?.optional?.flat(Infinity)  
        return (
          <div style={{color:huoquxuanz?.includes(option?.label)?"#006AFF":''}}>
             {option?.label}
          </div>
        );
      }}
    />
  );
};

export default observer(Classification);
